// Quantity Limit based on inventory
(function() {
  
  function getProductData() {
    // Cerca i dati del prodotto nella pagina
    const scripts = document.querySelectorAll('script[type="application/json"]');
    for (const script of scripts) {
      try {
        const data = JSON.parse(script.textContent);
        if (data.variants) return data.variants;
      } catch(e) {}
    }
    return null;
  }

  function getSelectedVariantId() {
    const input = document.querySelector('input[name="id"]');
    return input ? parseInt(input.value) : null;
  }

  function enforceQuantityLimit() {
    const variantId = getSelectedVariantId();
    if (!variantId) return;

    // Fetch variant data via Shopify AJAX API
    const productUrl = window.location.pathname + '.js';
    
    fetch(productUrl)
      .then(res => res.json())
      .then(product => {
        const variant = product.variants.find(v => v.id === variantId);
        if (!variant) return;

        const quantityInput = document.querySelector('input[name="quantity"]');
        const quantitySelector = document.querySelector('.quantity-selector');
        const plusBtn = document.querySelector('.quantity-plus, [name="plus"]');
        const minusBtn = document.querySelector('.quantity-minus, [name="minus"]');

        if (variant.inventory_management && variant.inventory_policy === 'deny') {
          const maxQty = variant.inventory_quantity;

          if (quantityInput) {
            // Imposta max
            quantityInput.setAttribute('max', maxQty);
            
            // Correggi valore se supera max
            if (parseInt(quantityInput.value) > maxQty) {
              quantityInput.value = maxQty;
            }

            // Se max è 1, nascondi il selettore
            if (maxQty <= 1 && quantitySelector) {
              quantitySelector.style.display = 'none';
              quantityInput.value = 1;
            } else if (quantitySelector) {
              quantitySelector.style.display = '';
            }
          }

          // Disabilita pulsante + se al max
          if (plusBtn && quantityInput) {
            const currentVal = parseInt(quantityInput.value) || 1;
            plusBtn.disabled = currentVal >= maxQty;
          }
        }
      })
      .catch(err => console.log('Error fetching product:', err));
  }

  // Intercetta click su + 
  document.addEventListener('click', function(e) {
    const plusBtn = e.target.closest('.quantity-plus, [name="plus"]');
    const minusBtn = e.target.closest('.quantity-minus, [name="minus"]');
    
    if (plusBtn || minusBtn) {
      setTimeout(() => {
        const quantityInput = document.querySelector('input[name="quantity"]');
        const max = parseInt(quantityInput?.getAttribute('max'));
        
        if (max && quantityInput) {
          const currentVal = parseInt(quantityInput.value) || 1;
          
          if (currentVal > max) {
            quantityInput.value = max;
          }
          
          // Aggiorna stato pulsante +
          const plus = document.querySelector('.quantity-plus, [name="plus"]');
          if (plus) plus.disabled = currentVal >= max;
        }
      }, 50);
    }
  });

  // Osserva cambi di variante
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
        if (mutation.target.name === 'id') {
          setTimeout(enforceQuantityLimit, 100);
        }
      }
    });
  });

  // Osserva l'input della variante
  function startObserver() {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      observer.observe(variantInput, { attributes: true });
    }
  }

  // Ascolta anche eventi custom di Shopify
  document.addEventListener('variant:changed', enforceQuantityLimit);
  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-variant-input], [name="id"]')) {
      setTimeout(enforceQuantityLimit, 100);
    }
  });

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      enforceQuantityLimit();
      startObserver();
    });
  } else {
    enforceQuantityLimit();
    startObserver();
  }

  // Re-check periodicamente (fallback)
  setInterval(enforceQuantityLimit, 2000);

})();